<template>
  <div class="Contact" style="position:fixed">
      <b-container fluid style="padding-top: 100px; ">
        <b-row>
          <b-col cols="12 headerF"><HeaderFixed/></b-col>
          <b-col cols="12 headerM"><HeaderMobile/></b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
              <b-breadcrumb style=" background-color: #e9ecef78;">

                  <b-breadcrumb-item href="#home">
                    <router-link to="/">
                        <b-icon icon="house-door" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                        Home
                    </router-link>
                  </b-breadcrumb-item>

                 <b-breadcrumb-item href="#" active>Projects</b-breadcrumb-item>
              </b-breadcrumb>
            </b-col>
        </b-row>

        <b-row>
          <b-col col cols="12" sm="3" md="3" lg="3" class="sideNav">
              <ProjectSideNav />
          </b-col>
          <b-col col cols="12" sm="12" md="12" lg="3" class="dropdownmenu">
              <ProjectMobileDropDown/>
              <br>
          </b-col>

          <b-col col cols="12" sm="12" md="12" lg="9" style="height:75vh; overflow-y:scroll " class="shadow">
            <ProjectContent />
          </b-col>
        </b-row>
      </b-container>
      <br><br>
  </div>
</template>

<script>
import ProjectSideNav from '@/components/ProjectSideNav.vue'
import ProjectMobileDropDown from '@/components/ProjectMobileDropDown.vue'
import ProjectContent from '@/components/ProjectContent.vue'
import HeaderFixed from '@/components/HeaderFixed.vue'
import HeaderMobile from '@/components/HeaderMobile.vue'

export default {
  name: 'Project',
  components: {
    'ProjectSideNav' : ProjectSideNav,
    'ProjectMobileDropDown' : ProjectMobileDropDown,
    'ProjectContent' : ProjectContent,
      'HeaderFixed' : HeaderFixed,
      'HeaderMobile' : HeaderMobile
    }
}


</script>

<style scoped="true">
  li{
    padding:0;
  }

  body{
    overflow-y:hidden;
  }

  .headerF{
    display: block;
  }
  .headerM{
    display: none;
  }
  .sideNav{
    height:75vh;
    overflow-y:scroll;
  }
  .dropdownmenu{
    display: none;
  }

  @media (max-width: 768px) {
      .headerF{
        display: none;
      }
      .headerM{
        display: block;
      }
      .sideNav{
        /* height:50vh;
        overflow-y:hidden; */
        display: none
      }
      .dropdownmenu{
        display: block;
      }
    }
</style>
